import React, { useState } from 'react';
import './style.scss';
import { Caption } from 'views/mutual/caption';
import { PositionHeader } from './module/LeaseFund/positionHeader';
import { DomesticRealEstatePositionHeader } from './module/domesticRealEstate/positionHeader';
import {
  useDomesticRealEstatePositionListPage,
  useOverseasRealEstatePositionListPage,
  usePositionListPage,
} from './hooks';
import { LoadingContainer, LoadingSize } from 'views/mutual/loading';
import { PositionList } from './module/LeaseFund/positionList';
import { Pagination } from 'views/mutual/pagination';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { ComponentControl } from 'views/mutual/componentControl';
import { useLocation } from 'react-router-dom';
import { ProductType, ProductTypeMap } from 'constants/productType';
import { AccountTabs } from 'views/mutual/tabs/accountTabs';
import { OverseasRealEstatePositionHeader } from './module/overseasRealEstate/positionHeader';
import { DomesticRealEstatePositionList } from './module/domesticRealEstate/positionList';
import { OverseasRealEstatePositionList } from './module/overseasRealEstate/positionList';

// ProductTypeを詳細から戻ってきた場合に保持する
export type PositionLocationState = {
  productType: ProductType;
};

export const Position = () => {
  const location = useLocation();
  const locationState = location.state as PositionLocationState;
  const [selectedTabIndex, setSelectedIndex] = useState(0);
  const tabItems = [
    {
      title: ProductTypeMap[ProductType.LeaseFund].name,
      content: <LeaseFundPosition />,
      productType: ProductType.LeaseFund,
    },
    {
      title: ProductTypeMap[ProductType.DomesticRealEstate].name,
      content: <DomesticRealEstatePosition />,
      productType: ProductType.DomesticRealEstate,
    },
    {
      title: ProductTypeMap[ProductType.OverseasRealEstate].name,
      content: <OverseasRealEstatePosition />,
      productType: ProductType.OverseasRealEstate,
    },
  ];

  return (
    <div className="positionList">
      <AccountTabs tabItems={tabItems} />
    </div>
  );
};

export const LeaseFundPosition = () => {
  const { positionList, currentPage, setCurrentPage, perPageCount } = usePositionListPage();
  return (
    <div className="positionList">
      <Caption label="出資案件" />
      <div className="positionList_wrapper">
        <LoadingContainer isLoading={positionList.fetching}>
          <PositionHeader />
          <ComponentControl
            isLoading={positionList.fetching}
            items={positionList.data?.GetPositionList?.Data || []}
            noDataMessege="出資履歴はありません"
            componentName={PositionList}
          />
        </LoadingContainer>
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          fetchApi={() => {}}
          totalCount={positionList.data?.GetPositionList?.TotalCount || 0}
          perPageCount={perPageCount}
        />
      </div>
      <div className="positionList_disclaimer">
        <Description
          labelColor={labelColor.gray}
          labelSize={labelSize.small}
          label="※1　賃借人のほかに転借人、保証人等の実質的な与信先が存在する場合は、当該与信先の名称を記載しています。また、賃借人等の名称は正式名称ではなく略称を記載しています。事業の仕組みの詳細および賃借人等の正式名称については、案件資料をご確認ください。"
        />
        <Description
          labelColor={labelColor.gray}
          labelSize={labelSize.small}
          label="※2　償還通貨が米ドル建ての場合は1.00米ドル当たりの為替レート、償還通貨がユーロ建ての場合は1.00ユーロ当たりの為替レートを表示しています"
        />
      </div>
    </div>
  );
};

export const DomesticRealEstatePosition = () => {
  const { positionList, currentPage, setCurrentPage, perPageCount } = useDomesticRealEstatePositionListPage();
  return (
    <div className="positionList">
      <Caption label="出資案件" />
      <div className="positionList_wrapper">
        <LoadingContainer isLoading={positionList.fetching}>
          <DomesticRealEstatePositionHeader />
          <ComponentControl
            isLoading={positionList.fetching}
            items={positionList.data?.GetDomesticRealEstatePositionList?.Data || []}
            noDataMessege="出資履歴はありません"
            componentName={DomesticRealEstatePositionList}
          />
        </LoadingContainer>
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          fetchApi={() => {}}
          totalCount={positionList.data?.GetDomesticRealEstatePositionList?.TotalCount || 0}
          perPageCount={perPageCount}
        />
      </div>
    </div>
  );
};

export const OverseasRealEstatePosition = () => {
  const { positionList, currentPage, setCurrentPage, perPageCount } = useOverseasRealEstatePositionListPage();
  return (
    <div className="positionList">
      <Caption label="出資案件" />
      <div className="positionList_wrapper">
        <LoadingContainer isLoading={positionList.fetching}>
          <OverseasRealEstatePositionHeader />
          <ComponentControl
            isLoading={positionList.fetching}
            items={positionList.data?.GetOverseasRealEstatePositionList?.Data || []}
            noDataMessege="出資履歴はありません"
            componentName={OverseasRealEstatePositionList}
          />
        </LoadingContainer>
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          fetchApi={() => {}}
          totalCount={positionList.data?.GetOverseasRealEstatePositionList?.TotalCount || 0}
          perPageCount={perPageCount}
        />
      </div>
    </div>
  );
};
